import React from 'react'
import { TurnPanelConceptGallery } from './turn-panel-concepts'

export default function SecondRoundGallery() {
  return <TurnPanelConceptGallery round={2} />
}
